import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48487e19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_file_manager_new_folder_row",
  "data-kt-filemanager-template": "upload"
}
const _hoisted_2 = {
  id: "kt_file_manager_add_folder_form",
  class: "fv-row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "svg-icon svg-icon-2x svg-icon-primary me-4" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewFolder = _resolveComponent("NewFolder")!
  const _component_DropDownOption = _resolveComponent("DropDownOption")!
  const _component_KTDataTable = _resolveComponent("KTDataTable")!

  return (_openBlock(), _createBlock(_component_KTDataTable, {
    "table-data": _ctx.folders,
    "table-header": _ctx.tableHeaders,
    "row-class": { 'table-hover': true },
    layout: {
      enableItemsPerPageDropdown: false,
      searching: false,
      hideOnSinglePage: true,
      info: false,
    },
    "rows-per-page": 10,
    total: _ctx.folders.length
  }, _createSlots({
    "cell-name": _withCtx(({ row: item }) => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("span", {
            class: _normalizeClass(["file-icon", item.classIcon])
          }, null, 2)
        ]),
        _createElementVNode("a", {
          onClick: ($event: any) => (_ctx.onSelect(item)),
          class: "text-gray-800 text-hover-primary"
        }, _toDisplayString(item.name), 9, _hoisted_8)
      ])
    ]),
    "cell-size": _withCtx(({ row: item }) => [
      _createTextVNode(_toDisplayString(item.size), 1)
    ]),
    "cell-date_modified": _withCtx(({ row: item }) => [
      _createTextVNode(_toDisplayString(item.date_modified), 1)
    ]),
    "cell-action": _withCtx(({ row: item }) => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_DropDownOption, {
            item: item,
            onOnSelectViewOption: ($event: any) => (_ctx.onSelect(item)),
            onOnSelectDeleteOption: ($event: any) => (_ctx.onDelete(item))
          }, null, 8, ["item", "onOnSelectViewOption", "onOnSelectDeleteOption"])
        ])
      ])
    ]),
    _: 2
  }, [
    (_ctx.addingFolder)
      ? {
          name: "custom-row",
          fn: _withCtx(() => [
            _createElementVNode("tr", _hoisted_1, [
              _createElementVNode("td", _hoisted_2, [
                _createVNode(_component_NewFolder, {
                  defaultName: _ctx.newFolderName,
                  onSave: _ctx.onSaveFolder,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addingFolder = false))
                }, null, 8, ["defaultName", "onSave"])
              ]),
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ])
          ])
        }
      : undefined
  ]), 1032, ["table-data", "table-header", "total"]))
}